import request from '../libs/request';

const res = 'OpenApiPermission';

export default {
  queryForCheck(openUserID) {
    return request({
      url: `api/${res}/queryForCheck`,
      method: 'get',
      params: {
        openUserID
      }
    });
  },
  batchSave(openUserID, openApiIDs) {
    return request({
      url: `api/${res}/batchSave`,
      method: 'post',
      data: {
        openUserID,
        openApiIDs
      }
    });
  }
};
